import { render, staticRenderFns } from "./actPlaceDetail.vue?vue&type=template&id=135d1c49"
import script from "./actPlaceDetail.vue?vue&type=script&lang=js"
export * from "./actPlaceDetail.vue?vue&type=script&lang=js"
import style0 from "./actPlaceDetail.vue?vue&type=style&index=0&id=135d1c49&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports